module.exports = __webpack_public_path__ + "fonts/05705B17EA9710EC1.eot";